import type { Ref } from 'vue'

export type AlertTone = 'danger' | 'info'

export function modalAlertClass(tone: AlertTone): Record<string, boolean> {
  return {
    'alert-info': tone === 'info',
    'alert-danger': tone === 'danger',
  }
}

export function showModalInfo(messageRef: Ref<string>, toneRef: Ref<AlertTone>, message: string): void {
  toneRef.value = 'info'
  messageRef.value = message
}

export function showModalError(messageRef: Ref<string>, toneRef: Ref<AlertTone>, message: string): void {
  toneRef.value = 'danger'
  messageRef.value = message
}

export function clearModalAlert(messageRef: Ref<string>, toneRef: Ref<AlertTone>): void {
  toneRef.value = 'danger'
  messageRef.value = ''
}
